module.exports = __webpack_public_path__ + "img/red_star.c475b87f.jpg";